export default "/images/vendor/@coreui/icons/svg/flag/cif-us.svg?f1dedf0601451608cdcdbcd45e2e8707";